var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"cursor-pointer hover:italic hover:underline text-primary",on:{"click":function($event){$event.stopPropagation();return _vm.goUrl.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.params.data.Title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }